export default __webpack_public_path__ + "static/media/location.106c23d1.svg";